/* src/app/shared/components/preview.modal/preview.modal.component.scss */
.ahe-ui-alert-modal .modal-dialog .modal-content {
  padding: 0px;
}
.modal-dialog {
  position: fixed;
  top: 50%;
  z-index: 1010;
  margin: 0px auto;
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
#common-modal .modal-body,
#common-modal .modal-footer {
  padding: 30px;
}
#common-modal .modal-footer {
  display: inline-block;
  text-align: left;
}
.modal-content {
  z-index: 1010;
  text-align: left;
}
.modal-dialog {
  position: relative;
  top: 50%;
  width: 300px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info {
  position: fixed;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
  left: calc(50% - 150px);
}
.modal-dialog-more-info-new {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-more-info-new .modal-content {
  height: 500px;
}
.modal-dialog-more-info-new .modal-content .iframe-body-single {
  height: 380px;
  width: 552px;
}
.modal-dialog-more-info-new .modal-content .iframe-body-multiple {
  height: 284px;
  width: 552px;
  border: none;
}
.modal-dialog-copy {
  position: relative;
  top: 50%;
  width: 600px;
  z-index: 1010;
  margin: 0px auto;
  -webkit-transform: translateY(-50%);
  transform: translateY(-50%);
}
.modal-dialog-copy .modal-content {
  height: 250px;
}
.modal-overlay {
  background-color: rgba(0, 0, 0, 0.2);
}
.modal-container-new {
  position: relative;
  width: 100%;
  background: transparent;
  height: 100%;
}
.modal-header-new {
  background: #174d5c;
  padding: 11px 30px;
  color: #fff;
  height: 45px;
}
.modal-body-new {
  position: relative;
  flex: 1 1 auto;
  padding: 10px 0 0 30px;
}
.modal-body-copy {
  position: relative;
  flex: 1 1 auto;
  padding: 30px 0 0 30px;
}
.label-info {
  font-size: 14px;
  font-weight: bold;
}
.label-span {
  font-size: 14px;
}
.label-question {
  font-weight: normal;
  font-size: 12px;
}
.label-span-question {
  font-weight: normal;
  font-size: 12px;
}
.modal-footer-new {
  display: flex;
  align-items: center;
  padding: 1rem;
  padding-left: 30px;
  border-top: 1px solid #e9ecef;
}
.modal-footer-new button {
  width: 130px;
}
#previewModal #previewModalOverlay {
  background-color: rgba(0, 0, 0, 0.2);
}
#previewModal .modal-dialog {
  transform: translateX(-247%) translateY(-50%);
}
#previewModal .modal-dialog #previewIframe {
  border: none;
  width: 700px;
  min-height: 800px;
}
#previewModal .modal-dialog .preview-model-content {
  width: 800px !important;
  height: 600px !important;
}
.preview-content {
  width: 800px !important;
  height: 580px !important;
}
.modifiePreviewdHeight {
  height: 630px !important;
}
.preview-body {
  width: 700px !important;
  height: 345px !important;
  border-radius: 10px;
  border: none;
}
button.close {
  padding: 0;
  cursor: pointer;
  background: transparent;
  border: 0;
  -webkit-appearance: none;
}
.close {
  height: 26px;
  width: 26px;
  float: right;
  font-size: 21px;
  font-weight: bold;
  line-height: 1;
  color: #000;
  text-shadow: 0 1px 0 #fff;
  opacity: 1;
  filter: alpha(opacity=30);
}
.question-body {
  width: 735px !important;
  height: 398px !important;
  border: 1px solid gray;
}
.question-sequence {
  width: 733px !important;
  height: 40px;
  background-color: #c1cfd4;
  font-size: 16px;
}
::ng-deep .alert-info {
  display: inline-block;
  width: 45%;
  margin-left: 100px;
}
::ng-deep .alert-success {
  margin-bottom: 0px;
}
.marginAuto {
  margin: auto;
  width: 50%;
}
/*# sourceMappingURL=preview.modal.component.css.map */
